const validId = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
const record = value => value && typeof value === 'object' && !Array.isArray(value);
const fail = () => {throw Object.assign(new Error('Assembly governance records are unavailable or invalid.'), {code: 'INVALID_API_RESPONSE'});};
export function readAssemblyGovernanceResponse(payload, assemblyId = payload?.data?.assemblyId) {
  const data = payload?.data;
  if (payload?.success !== true || !record(data) || !validId(assemblyId) || data.assemblyId !== assemblyId || !validId(data.communityId)
    || !Number.isSafeInteger(data.revision) || data.revision < 0 || typeof data.canManage !== 'boolean' || typeof data.managed !== 'boolean' || data.canAssign !== undefined && typeof data.canAssign !== 'boolean'
    || !['terms', 'members', 'offices', 'evidence', 'history', 'delegations', 'decisions', 'sources', 'issues', 'categories', 'appointments'].every(key => Array.isArray(data[key]))
    || data.approvalReviews !== undefined && (!Array.isArray(data.approvalReviews) || data.approvalReviews.some(row => !['budget', 'expense'].includes(row.kind) || !validId(row.id) || typeof row.title !== 'string'))
    || data.members.some(row => !validId(row.membershipId) || typeof row.name !== 'string')
    || data.evidence.some(row => !validId(row._id) || row.assembly !== assemblyId || typeof row.reference !== 'string')
    || data.history.some(row => !validId(row._id) || row.assembly !== assemblyId || typeof row.action !== 'string')) fail();
  return data;
}
export const createAssemblyGovernanceClient = (adapter, assemblyId, options = {}) => {
  if (!validId(assemblyId)) throw new Error('Select a valid Assembly.');
  const path = `/api/assembly/${assemblyId}/governance`;
  return {
    async get() {return readAssemblyGovernanceResponse(await adapter.get(path, options), assemblyId);},
    async record(input) {
      if (!record(input) || !Number.isSafeInteger(input.revision) || !/^[a-zA-Z0-9_-]{8,128}$/.test(input.requestId || '')) throw new Error('Reload governance records before saving.');
      return readAssemblyGovernanceResponse(await adapter.post(path, input, options), assemblyId);
    },
    async candidates(q) {
      const response = await adapter.get(`${path}/candidates?q=${encodeURIComponent(q || '')}`, options);
      return readAssemblyGovernanceCandidatesResponse(response);
    },
  };
};

export function readTreasuryAuthorityResponse(payload) {
  const data = payload?.data;
  if (!record(data) || typeof data.managed !== 'boolean' || data.canAssign !== undefined && typeof data.canAssign !== 'boolean' || !Array.isArray(data.evidence) || !Array.isArray(data.delegations)
    || data.evidence.some(row => !validId(row.id) || typeof row.reference !== 'string')
    || data.delegations.some(row => !validId(row.id) || typeof row.reference !== 'string' || !Number.isSafeInteger(row.maximumMinor))) fail();
  return data;
}
export const createTreasuryAuthorityLoader = (adapter, options = {}) => async () => readTreasuryAuthorityResponse(await adapter.get('/api/treasury/authority', options));

export function readAssemblyGovernanceCandidatesResponse(payload) {
  if (payload?.success !== true || !Array.isArray(payload.data?.data) || typeof payload.data.more !== 'boolean'
    || payload.data.data.length > 30 || payload.data.data.some(row => !validId(row.id) || typeof row.name !== 'string' || typeof row.status !== 'string')) fail();
  return payload.data;
}
